import { render, staticRenderFns } from "./r-item-info-config.vue?vue&type=template&id=7d6ed5bc"
import script from "./r-item-info-config.vue?vue&type=script&lang=js"
export * from "./r-item-info-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d6ed5bc')) {
      api.createRecord('7d6ed5bc', component.options)
    } else {
      api.reload('7d6ed5bc', component.options)
    }
    module.hot.accept("./r-item-info-config.vue?vue&type=template&id=7d6ed5bc", function () {
      api.rerender('7d6ed5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/info/r-item-info-config.vue"
export default component.exports